module.exports = __webpack_public_path__ + "static/img/model-bg19.8e7f342.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg19.jpg
// module id = okfo
// module chunks = 0